import { User } from './action-types';
import history from '../history';
import { USER_STUB } from '../tests/fixtures/stubs/user';
import { showFeedback } from './ui';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../core/net';
import { AmplifyCore, authenticationContext, commonEnums, HttpMethods } from '@codametrix/ui-common';
const { paginationUtils } = AmplifyCore;
const { FilterTypes } = commonEnums;
/** The sync action creators */ const userList = createAction(User.LIST);
const userSelected = createAction(User.USER_SELECTED);
const updateRole = createAction(User.ROLE_UPDATE);
const availableRoles = createAction(User.AVAILABLE_ROLES);
const availableOrgs = createAction(User.AVAILABLE_ORGANIZATIONS);
const formSubmissionError = createAction(User.FORM_SUBMISSION_ERROR);
const addUserDetails = createAction(User.ADD_USER_DETAILS);
const toggleForcePasswordOption = createAction(User.TOGGLE_PASSWORD_OPTIONS);
const togglePasswordChangeModal = createAction(User.TOGGLE_PASSWORD_CHANGE_MODAL);
const toggleFilterOn = createAction(User.TOGGLE_FILTER_ON);
const toggleShowErrors = createAction(User.TOGGLE_SHOW_ERRORS);
/** async actions */ const list = createAsyncThunk(User.LIST, async (params, { dispatch })=>{
    const sortablePageable = params;
    const searchParams = paginationUtils.searchParamsFactory(sortablePageable);
    let body = [];
    const filters = sortablePageable.filterableOptions.filters;
    if (filters) {
        filters.forEach((filter)=>{
            body.push(filter);
        });
    } else {
        body.push({
            key: 'role',
            terms: [
                'true'
            ],
            type: FilterTypes.IN
        });
    }
    const users = await api({
        endpoint: `/users/list/v1?${searchParams.toString()}`,
        init: {
            method: HttpMethods.POST
        },
        body: body
    });
    dispatch(userList(users));
    return users;
});
const updateUser = createAsyncThunk(User.ROLE_UPDATE, async (params, { dispatch })=>{
    const { user } = params;
    dispatch(updateRole(user));
    return user;
});
/** The asynchronous login action; Error type is optional */ const save = createAsyncThunk('Save User', async (params, { dispatch })=>{
    const { user, token } = params;
    const isUpdate = user.id !== null;
    const method = isUpdate ? HttpMethods.PUT : HttpMethods.POST;
    const endpoint = isUpdate ? `/users/${user.userId}/v1` : `/users/v1`;
    const userDetails = await api({
        endpoint,
        init: {
            method
        },
        headers: {
            Authorization: token.token
        },
        body: user
    });
    history.push('/cmx/admin/users/');
    dispatch(showFeedback({
        id: Date.now(),
        message: `Saved information for ${userDetails.firstName} ${userDetails.lastName}.`,
        dismissable: true
    }));
    return userDetails;
});
const dispatchOrgAndRoles = async (dispatch, orgContext)=>{
    const org = await api({
        endpoint: `/organization/id/v1?organizationId=${orgContext.organizationId}`
    });
    dispatch(availableOrgs(org));
    const roles = await api({
        endpoint: `/roles/v1/`
    });
    dispatch(availableRoles(roles));
};
const addUser = createAsyncThunk('Add User', async (params, { dispatch })=>{
    const { orgContext } = params;
    dispatch(userSelected(USER_STUB));
    history.push('/cmx/admin/users/new/');
    await dispatchOrgAndRoles(dispatch, orgContext);
});
const getDetail = createAsyncThunk(User.USER_SELECTED, async (params, { dispatch })=>{
    const { user, orgContext } = params;
    const userDetails = await api({
        endpoint: `/users/${user.userId}/v1`
    });
    dispatch(userSelected(userDetails));
    history.push(`/cmx/admin/users/${userDetails.id}/`);
    dispatchOrgAndRoles(dispatch, orgContext);
    return userDetails;
});
const getBasicUserDetail = createAsyncThunk('USER_BASIC_INFO_FETCHED', async (params, { dispatch })=>{
    const { userId } = params;
    const fullUser = await api({
        endpoint: `/users/${userId}/v1`
    });
    const { username, firstName, lastName } = fullUser;
    return {
        username,
        firstName,
        lastName
    };
});
const changeUsersPassword = createAsyncThunk(User.CHANGE_USERS_PASSWORD, async (userData, { dispatch })=>{
    const { selectedUser, ...passwords } = userData;
    const adminToken = authenticationContext.getToken();
    await api({
        endpoint: `/users/${selectedUser.userId}/v1`,
        init: {
            method: HttpMethods.PUT
        },
        headers: {
            Authorization: adminToken
        },
        body: {
            ...selectedUser,
            forcePasswordChange: true,
            password: passwords.newPassword,
            confirmPassword: passwords.newPasswordConfirm
        }
    });
});
export const actions = {
    list,
    userList,
    userSelected,
    updateRole,
    availableRoles,
    availableOrgs,
    formSubmissionError,
    save,
    addUser,
    addUserDetails,
    toggleForcePasswordOption,
    togglePasswordChangeModal,
    changeUsersPassword,
    toggleFilterOn,
    toggleShowErrors
};
export { getDetail, getBasicUserDetail, updateUser, addUser, save, list, addUserDetails, toggleForcePasswordOption, togglePasswordChangeModal, changeUsersPassword, toggleFilterOn, toggleShowErrors };
